import { z } from 'zod';
import { cleanText } from '../text.js';

/**
 * A string field that is normalized by cleanText() BEFORE the inner
 * constraints run, so min()/max()/refine() judge the value that will actually
 * be stored (a name that is only no-break spaces fails min(1); a "Last, First"
 * check sees a real comma-space). Input and output types both stay `string`,
 * so FE form resolvers and API parsers are unaffected (T-200).
 *
 *   product_service: cleanString(z.string().min(1).max(400)),
 *   role: cleanString(z.string().max(200)).nullable().optional(),
 */
export function cleanString<T extends z.ZodType<unknown, string>>(inner: T) {
  return z.string().transform(cleanText).pipe(inner);
}
